import React from "react";
import { useEffect, useState } from "react";
import { GetSalesByPerson, PostPaymentDue } from "../../util/APIUtils";
import PaymentDueBody from "./PaymentDueBody";
import { useMemo } from "react";
import { LoadingOverlay } from "../../util/Helpers";

export default function PaymentDue() {
  const [values, setValues] = useState({ name: "test" });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);
  const [hide, setHide] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    PostPaymentDue(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const showSales = (row) => {
    let obj = { salesPersonName: row.salesPersonName };
    setBlock(true);
    GetSalesByPerson(obj).then((response) => {
      setItems(response);
      setBlock(false);
      setHide(!hide);
      setBlock(false);
    });
  };
  const Onback = () => {
    setHide(!hide);
  };
  const memoizedTrans = useMemo(() => trans, [trans]);
  const memoizedItems = useMemo(() => items, [items]);
  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <PaymentDueBody
        data={memoizedTrans}
        showSales={showSales}
        hide={hide}
        Onback={Onback}
        items={memoizedItems}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PaymentDue.js